import { gql } from '@apollo/client'

// Both return `image` and `updatedAt` so Apollo updates the cached channel
// without a refetch.
export const UPLOAD_CHANNEL_IMAGE = gql`
  mutation UploadChannelImage($channelId: ID!, $imageBase64: String!, $contentType: String!) {
    uploadChannelImage(input: { channelId: $channelId, imageBase64: $imageBase64, contentType: $contentType }) {
      channel {
        id
        image
        updatedAt
      }
      errors
    }
  }
`

export const DELETE_CHANNEL_IMAGE = gql`
  mutation DeleteChannelImage($channelId: ID!) {
    deleteChannelImage(input: { channelId: $channelId }) {
      channel {
        id
        image
        updatedAt
      }
      errors
    }
  }
`
